let htmlAcceptHeader = 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8'

export const fetchHtml = async (resource, init = {}) => {
    init.headers = {
        'Accept': htmlAcceptHeader,
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        ...init.headers,
    }

    const response = await fetch(resource, init)
    if (!response.ok) {
        throw new Error(response.statusText)
    }

    return await response.text()
}

export const fetchJson = async (resource, init = {}) => {
    init.headers = {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        ...init.headers,
    }

    const response = await fetch(resource, init)

    const data = await response.json()

    // Error codes != 200...299
    if (!response.ok) {
        const error = new Error(data.message)
        error.errors = data.errors
        throw error
    }

    return data
}

export const formErrors = (form, error) => {
    if (error.errors && Object.keys(error.errors).length) {
        for (let inputName in error.errors) {
            const element = form.elements[inputName]

            if (element) {
                const errorElement = element.parentElement.querySelector('.form-control__hint.error')

                const errorText = Array.isArray(error.errors[inputName]) ? error.errors[inputName].join(', ') : error.errors[inputName]

                if (errorElement) {
                    errorElement.textContent = errorText
                } else {
                    element.parentElement.insertAdjacentHTML('beforeend', `<span class="form-control__hint error">${errorText}</span>`)
                }
            }
        }
    } else {
        const allControls = form.querySelectorAll('.form-control')

        if (allControls) {
            const errorControl = allControls[allControls.length - 1]

            if (errorControl) {
                const errorElement = errorControl.querySelector('.form-control__hint.error')

                if (errorElement) {
                    errorElement.textContent = error.message
                } else {
                    errorControl.insertAdjacentHTML('beforeend', `<span class="form-control__hint error">${error.message}</span>`)
                }
            }
        }
    }
}
